<template>
  <ORow center-y center-x style="width: auto">
    <v-btn icon @click="navigate(-1)">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <div style="width: 350px" class="mx-2">
      <DateRangePicker
        label="Filtrar por Período"
        orientation="horizontal"
        :value="value"
        @input="(v) => $emit('input', v)"
      >
        <div v-if="stats != null" class="pa-4">
          <v-alert outlined color="info">
            Este veículo possui {{ stats.count }} coordenadas disponíveis desde
            <code>{{ stats.min.timestamp }}</code> até
            <code>{{ stats.max.timestamp }}</code>
            .
          </v-alert>
        </div>
      </DateRangePicker>
    </div>
    <v-btn icon @click="navigate(1)">
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
  </ORow>
</template>

<script>
import DateRangePicker from 'oderon-vue/cpts/pickers/DateRangePicker.vue'
import moment from 'moment'

export default {
  components: {
    DateRangePicker
  },
  props: {
    stats: {},
    value: { type: Array, required: true }
  },
  methods: {
    navigate(n) {
      let newVal = [
        moment(this.value[0])
          .add(n, 'days')
          .toDate(),
        moment(this.value[1])
          .add(n, 'days')
          .toDate()
      ]

      this.$emit('input', newVal)
    }
  }
}
</script>

<style></style>
